import { createAction } from '@reduxjs/toolkit';
import { HIDE_MODAL, SHOW_MODAL, SET_SELECTED_DEALER_ID_MODAL_DATA } from './actionTypes';
export const setIsModalShowed = createAction(SHOW_MODAL);
export const setIsModalHide = createAction(HIDE_MODAL);
export const setSelectedDealerIdModalData = createAction(SET_SELECTED_DEALER_ID_MODAL_DATA);
